/* eslint-disable no-undef */
import $ from "jquery";

const tableScroll = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    $(function () {
      var container = document.querySelector(".AccountPage .table-wrapper");
      container?.addEventListener("mousewheel", function (event) {
        container.scrollLeft += event.deltaY;
        event.preventDefault();
      });
    });
  };

  init();
};

try {
  tableScroll();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
